import { IUntypedQuery, Topics } from '@zaplify/common';

export class GetCleanedOrganizationsQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly organizationNames: string[]) {
        super();
    }
}
